/**
 * InfoLibrary Routes Configuration
 *
 * Extracted from the main router for better organization.
 */

import type { RouteRecordRaw } from 'vue-router'
import { loadLocales } from '@/utils/i18n.utils'
import { br } from '@/plugins/trackerPlugin'

const InfoLibraryLayout = () => import('@/layouts/InfoLibraryLayout.vue')
const LibraryPage = () => import('@/pages/infoLibrary/Library.vue')

export function getInfoLibraryRoutes(): RouteRecordRaw {
  return {
    name: 'infoLibraryLayout',
    path: 'infoLibrary',
    alias: '',
    component: InfoLibraryLayout,
    beforeEnter: async () => {
      await loadLocales('library')
    },
    props: true,
    meta: {
      requiresAuth: true,
      requiresMatched: true,
      trackingName: br.appActionFeature.infoLibrary,
      section: 'infoLibrary'
    },
    children: [
      {
        name: 'infoLibrary',
        path: '/infoLibrary/',
        component: LibraryPage,
        props: true,
        meta: { requiresAuth: true }
      }
    ]
  }
}
